import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar    from './components/Navbar';
import Footer    from './components/Footer';
import Landing   from './pages/Landing';
import Search    from './pages/Search';
import Chat      from './pages/Chat';
import Collection from './pages/Collection';
import Pricing   from './pages/Pricing';
import Blog      from './pages/Blog';
import BlogPost  from './pages/BlogPost';
import Admin     from './pages/Admin';

function PrivateRoute({ children }) {
  const { isLoggedIn } = useAuth();
  return isLoggedIn() ? children : <Navigate to="/" replace />;
}
function AdminRoute({ children }) {
  const { isAdmin } = useAuth();
  return isAdmin() ? children : <Navigate to="/" replace />;
}

function PublicLayout() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar/>
      <main className="flex-1">
        <Routes>
          <Route path="/"           element={<Landing/>}/>
          <Route path="/search"     element={<Search/>}/>
          <Route path="/chat"       element={<Chat/>}/>
          <Route path="/pricing"    element={<Pricing/>}/>
          <Route path="/blog"       element={<Blog/>}/>
          <Route path="/blog/:slug" element={<BlogPost/>}/>
          <Route path="/collection" element={<PrivateRoute><Collection/></PrivateRoute>}/>
          <Route path="*"           element={<Navigate to="/" replace/>}/>
        </Routes>
      </main>
      <Footer/>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/admin/*" element={<AdminRoute><Admin/></AdminRoute>}/>
          <Route path="/*"       element={<PublicLayout/>}/>
        </Routes>
      </Router>
    </AuthProvider>
  );
}
